function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.822,0A4.418,4.418,0,0,0,1.9,2.075a.548.548,0,0,0,.118.75L3,3.571a.547.547,0,0,0,.758-.095A2.212,2.212,0,0,1,5.645,2.349c.7,0,1.569.451,1.569,1.132,0,.514-.424.778-1.117,1.167C5.289,5.1,4.22,5.663,4.22,7.073V7.3a.547.547,0,0,0,.547.547H6.42A.547.547,0,0,0,6.967,7.3V7.165c0-.977,2.856-1.018,2.856-3.662C9.824,1.511,7.758,0,5.822,0ZM5.594,8.515a1.579,1.579,0,1,0,1.579,1.579A1.581,1.581,0,0,0,5.594,8.515Z",
  transform: "translate(-1.8)"
});

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.024,
    height: 11.674,
    viewBox: "0 0 8.024 11.674",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.4c71147c.svg";
export { ForwardRef as ReactComponent };